import * as customersApi from '@/network/api/customers/customers.api.js'

/** Fetch Customer Info
@return { promise } - Customer Info request
*/
export const requestCustomerInfo = async context => {
    const res = await customersApi.requestCustomerInfo()

    if (res) {
        const data = res.data.data
        context.commit('SAVE_CUSTOMER_INFO', data)
    }
    return res
}

/** Update Customer Image
@return { promise }
*/
export const updateCustomerImage = async (context, payload) => {
    const res = await customersApi.updateCustomerImage(payload)

    return res
}

/** Delete Customer Image
@return { promise }
*/
export const deleteCustomerImage = async context => {
    const res = await customersApi.deleteCustomerImage()

    return res
}

/** Request Default PhoneNumber Update
@return { promise } - Default PhoneNumber Update
*/
export const requestChangeDefaultPhoneNumber = async (context, payload) => {
    const res = await customersApi.requestChangeDefaultPhoneNumber(payload)

    if (res) {
        context.commit('UPDATE_DEFAULT_PHONENUMBER', payload)
    }
    return res
}

/** Changes User Friendly Name
@return { promise }
*/
export const changeUserFriendlyName = async (context, payload) => {
    const res = await customersApi.changeUserFriendlyName(payload)

    return res
}
